var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ThemeUtils } from '../../../../../utils';
import { Text, TextHtmlTags, TextHyphens, TextVariants } from '../../../../atoms/text';
var PH = function (_a) {
    var props = __rest(_a, []);
    var productName = props.productName, description = props.description;
    var productNameConfig = {
        content: productName,
        component: TextHtmlTags.H1,
        hyphens: TextHyphens.None
    };
    var productDescriptionConfig = {
        content: description,
        component: TextHtmlTags.P,
        variant: TextVariants.Body1
    };
    var productNameMobileConfig = __assign(__assign({}, productNameConfig), { variant: TextVariants.H5 });
    var productNameDesktopConfig = __assign(__assign({}, productNameConfig), { variant: TextVariants.H3 });
    return (React.createElement(React.Fragment, null, ThemeUtils.getResponsiveRender([
        React.createElement(Text.TextSection, null,
            productName && React.createElement(Text, __assign({ key: "0" }, productNameMobileConfig)),
            description && React.createElement(Text, __assign({ key: "1" }, productDescriptionConfig))),
        null,
        null,
        React.createElement(Text.TextSection, null,
            productName && React.createElement(Text, __assign({ key: "0" }, productNameDesktopConfig)),
            description && React.createElement(Text, __assign({ key: "1" }, productDescriptionConfig)))
    ])));
};
export { PH as ProductHeader };
